

function BuildGallery() {
   
    window.BuildDetailGallery();


}

export default function () {

    BuildGallery();
}


const galleryReload = (images) => {

  
    window.DetailMainCarousel.destroy();


    const container = document.getElementById("detail-carousel");
    container.innerHTML = "";
   
    images.forEach((pic, index) => {
        const pictureEl = document.createElement("picture");
        pictureEl.dataset.fancybox = "product";
        pictureEl.title = pic.ImageAlt || "";
        pictureEl.className = "f-carousel__slide size-full";
        pictureEl.dataset.thumbSrc = pic.SmallPathName;
        pictureEl.dataset.thumbAlt = pic.ImageAlt || "";
        pictureEl.dataset.src = pic.SourcePathName;

        const source = document.createElement("source");
        source.media = "(max-width: 600px) and (max-resolution: 1.9dppx)";

        source.srcset = pic.SmallPathName;
   

        const img = document.createElement("img");
        img.width = pic.WidthPx; 
        img.height = pic.HeightPx;
        img.alt = pic.ImageAlt || "";
        img.src = pic.SourcePathName;


        pictureEl.appendChild(source);
        pictureEl.appendChild(img);
        container.appendChild(pictureEl);
    });

    BuildGallery();


};

export { galleryReload };